export default __webpack_public_path__ + "static/3-962880a9766333d3b22e04e4117ae344.png";